import { render, staticRenderFns } from "./TaxasParametrizadasItems.vue?vue&type=template&id=a113a614"
import script from "./TaxasParametrizadasItems.vue?vue&type=script&lang=js"
export * from "./TaxasParametrizadasItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports